import './_index.scss';
import customSelects from "custom-select";

export default function Index() {
    const $index = document.querySelector('.index-component') as HTMLElement;
    if ($index) {
        const anchors: any = $index.querySelectorAll('.content [id]');
        const links = $index.querySelectorAll('.list-items a');
        links[0]?.classList.add('active');

        function progress() {
            const progressBar = $index.querySelector('.progress-bar') as HTMLElement;
            let winScroll = document.body.scrollTop || document.documentElement.scrollTop;
            let height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
            let scrolled = (winScroll / height) * 100;
            progressBar.style.width = scrolled + "%";
        }

        window.addEventListener('scroll', () => {
            progress();
        });

        function highlightLink() {
            const scrollPosition = window.scrollY;

            anchors.forEach((item: any, index: number) => {
                const targetId = item.getAttribute('id');
                const correspondingLink = $index.querySelector(`.list-items a[href="#${targetId}"]`);
                const targetElement = $index.querySelector(`[id="${targetId}"]`);

                if (targetElement) {
                    const topOffset = item.getBoundingClientRect().top + scrollPosition;
                    const bottomOffset = topOffset + targetElement.clientHeight;

                    if ((index === anchors.length - 1) && (topOffset <= scrollPosition + 442) && (bottomOffset >= scrollPosition)) {
                        links.forEach(link => {
                            link?.classList.remove('active');
                        });
                        correspondingLink && correspondingLink?.classList.add('active');
                    } else if ((index < anchors.length - 1) && (topOffset <= scrollPosition + 150) && (bottomOffset >= scrollPosition)) {
                        links.forEach(link => {
                            link?.classList.remove('active');
                        });
                        correspondingLink && correspondingLink?.classList.add('active');
                    }
                }
            });
        }


        if (window.innerWidth > 768) {
            window.addEventListener('scroll', () => {
                highlightLink();

                links.forEach((link: any) => {
                    link.addEventListener('click', (event: Event) => {
                        event.preventDefault();

                        const targetId = link.getAttribute('href').substring(1);
                        const targetElement = document.getElementById(targetId);

                        if (targetElement) {
                            const offsetTop = targetElement.offsetTop;

                            window.scrollTo({
                                top: offsetTop,
                                behavior: 'smooth',
                            });
                        }
                    });
                });
            });
        } else {
            const selectCustom = customSelects($index.querySelector('select'));
            const selectCustomCont = selectCustom[0].select.customSelect as any;
            const selectContainer = selectCustomCont.container;
            const selectPanel = selectContainer.querySelector('.custom-select-opener');
            const optionsCustom = Array.from(selectContainer.querySelectorAll('.custom-select-option'));

            selectPanel.addEventListener('keypress', function (e: any) {
                if (e.code === 'Enter') {
                    selectContainer.classList.toggle('is-open');
                }
            });

            const select = $index.querySelector('.select') as any;
            const customDropdown = $index.querySelector('.custom-select-opener') as any;
            const opt = $index.querySelectorAll('option');
            const targets = $index.querySelectorAll('.content [id]');
            let currentVisibleSectionId: any = null;

            function updateActiveSection() {
                const scrollPosition = window.scrollY || document.documentElement.scrollTop;

                targets.forEach((target: any, index: number) => {
                    const topOffset = target.getBoundingClientRect().top + scrollPosition;
                    const targetId = target.id;

                    if (targetId) {
                        currentVisibleSectionId = targetId;

                        if ((index === targets.length - 1) && (topOffset <= scrollPosition + 442)) {
                            opt.forEach(op => {
                                if (op.value === targetId) {
                                    customDropdown.querySelector('span').innerHTML = op.innerHTML;
                                    select.value = targetId;
                                }
                            });
                        } else if ((index < targets.length - 1) && (topOffset <= scrollPosition + 300)) {
                            opt.forEach(op => {
                                if (op.value === targetId) {
                                    customDropdown.querySelector('span').innerHTML = op.innerHTML;
                                    select.value = targetId;
                                }
                            });
                        }
                    }
                });

                if (!currentVisibleSectionId) {
                    select.value = '';
                }
            }

            window.addEventListener('scroll', () => {
                updateActiveSection();
            });

            select.addEventListener('change', () => {
                const element = document.getElementById(select.value) as any;
                if (element) {
                    const offsetInPixels = 50;
                    const elementPosition = element.getBoundingClientRect().top + window.scrollY;
                    const offsetPosition = elementPosition - offsetInPixels;

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth'
                    });
                }
            });

            optionsCustom.forEach((option: any) => {
                const span = customDropdown.querySelector('span') as HTMLElement;
                option.setAttribute('tabindex', '0');
                option.addEventListener('keypress', function (e: any) {
                    if (e.code === 'Enter') {
                        span.innerHTML = option.innerHTML;
                        selectContainer.classList.remove('is-open');
                    }
                });
            });
        }
    }
}